// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".i21gE-QRState-module_root{text-align:center;font-size:0;display:flex;flex:1;flex-direction:column;align-items:center}.FAxIx-QRState-module_description{margin-bottom:1.3333333333rem}.zgyiA-QRState-module_qr+.poI4q-QRState-module_timer{margin-top:1rem}.zgyiA-QRState-module_qr+.d6vZX-QRState-module_buttons,.poI4q-QRState-module_timer+.d6vZX-QRState-module_buttons{margin-top:1.3333333333rem}.d6vZX-QRState-module_buttons{display:flex;align-items:center;gap:1rem;width:100%}.tX4Li-QRState-module_button{flex:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "i21gE-QRState-module_root",
	"description": "FAxIx-QRState-module_description",
	"qr": "zgyiA-QRState-module_qr",
	"timer": "poI4q-QRState-module_timer",
	"buttons": "d6vZX-QRState-module_buttons",
	"button": "tX4Li-QRState-module_button"
};
export default ___CSS_LOADER_EXPORT___;
